export default "__VITE_ASSET__cbf4d7d0__"